import React, { useState, useEffect } from "react";
import { Button, Row, Col, Container, Form } from "react-bootstrap"
import axios from "axios";
import toast from "react-hot-toast";
import ToastComponent from "./components/ToastComponent";

function NewCustomer() {
  const [result, setResult] = useState();
  const [firstname, setFirstname] = useState();
  const [surname, setSurname] = useState();
  const [email, setEmail] = useState();
  const [address, setAddress] = useState();


  const createCustomer = () => {
    let senddata =
      axios.post(`${process.env.REACT_APP_API ? process.env.REACT_APP_API : window.location.origin}/gui/v1/customer.json`,
        {
          customer: {
            first_name: firstname,
            surname: surname,
            email: email,
            address, address
          }
        }
      )
      .then(( { data }) => {
        setResult(data)
      
      toast.promise(senddata, {
        loading: "Creating Customer",
        success: "Customer Created",
        error:   "Could not create Customer"
      })
    })
  }

  return (
    <div>
      <ToastComponent />
      <Container>
        <Form>
          <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
          <Form.Label column sm="2" className="Register-Label">
                Firstname
              </Form.Label>
              <Col sm="10">
                <Form.Control onChange={(e) => setFirstname(e.target.value)} />
              </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
          <Form.Label column sm="2" className="Register-Label">
                Surname
              </Form.Label>
              <Col sm="10">
                <Form.Control onChange={(e) => setSurname(e.target.value)} />
              </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
          <Form.Label column sm="2" className="Register-Label">
                E-Mail
              </Form.Label>
              <Col sm="10">
                <Form.Control onChange={(e) => setEmail(e.target.value)} />
              </Col>
          </Form.Group>

        </Form>
        <Button onClick={() => createCustomer()}>Create</Button>
      </Container>
    </div>

  )
}

export default NewCustomer